import { Lock } from 'lucide-react';
import { Button, Card, EmptyState } from '../../ui';

const NoAccess = ({
  title = 'No Access',
  message = "You don't have access to anything on this dashboard yet. Contact your account administrator.",
  onRetry,
}) => (
  <Card>
    <EmptyState
      icon={<Lock className="h-10 w-10" aria-hidden="true" />}
      title={title}
      message={message}
      action={onRetry && <Button onClick={onRetry}>Try again</Button>}
    />
  </Card>
);

export default NoAccess;
